import { Component } from '@angular/core';

@Component({
  selector: 'wchfs-search-form',
  templateUrl: './search-form.component.html',
  styleUrls: ['./search-form.component.scss'],
})
export class SearchFormComponent {}
